import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.558 15q-1.278 0-1.922-.636Q0 13.737 0 12.474V2.526Q0 1.263.636.636 1.28 0 2.558 0h9.884q1.278 0 1.914.636.645.627.644 1.89v9.948q0 1.263-.644 1.89-.635.636-1.914.636zm.017-1.312h9.85q.603 0 .93-.318.333-.325.333-.961V2.591q0-.636-.334-.953-.326-.326-.929-.326h-9.85q-.612 0-.937.326-.326.318-.326.953v9.818q0 .636.326.961.326.318.937.318M10.062 9.5a.6.6 0 0 1-.44-.17q-.162-.173-.162-.465v-1.41l.122-1.263L8.417 7.44 5.41 10.445a.63.63 0 0 1-.464.188.58.58 0 0 1-.432-.163.62.62 0 0 1-.163-.448.6.6 0 0 1 .195-.432l3.007-3.007 1.263-1.181-1.206.13H6.127a.68.68 0 0 1-.472-.163.58.58 0 0 1-.172-.44q0-.269.172-.431a.63.63 0 0 1 .456-.163h3.87q.31 0 .489.154.187.155.187.522v3.837q0 .285-.163.473a.56.56 0 0 1-.431.18"
    }, null, -1)
  ]))]))
}
export default { render: render }